import React from 'react';
import moment from 'moment';

const BookingReportchekin = ({ contentRef, DataObj }) => {
  return (
    <div ref={contentRef} style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: 'white', }}>
      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 768px) {
            h1, h2, h3 {
              font-size: 16px !important;
              text-align: center;
            }

            table {
              font-size: 12px;
            }

            td, th {
              padding: 6px !important;
            }
          }

          .sticky-section-header {
            position: sticky;
            top: 0;
            z-index: 2;
            background-color: white;
            color: #635bff;
            font-weight: bold;
            padding: 4px 0;
            border-bottom: 1px solid #e5e7eb;
            margin-bottom: 8px;
            font-size: 16px;
            text-align: start;
          }
        `}
      </style>


      {/* Header */}
      <div style={{ marginBottom: '14px' }}>
        <h1 style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center', color: '#635bff', marginBottom: '3px' }}>Clanbridge Living Pvt Ltd</h1>
        <h2 style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '8px' }}>Booking Confirmation</h2>
      </div>

      {/* Booking Summary */}
      <div style={{ marginBottom: '14px', overflowX: 'auto' }}>
        <table style={{ minWidth: '600px', width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
          <thead>
            <tr style={{ backgroundColor: '#635bff' }}>
              <th colSpan="4" style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'start', color: 'white', fontWeight: 'bold' }}>
                Booking Summary
              </th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Booking No</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.BookNo || DataObj.DocNo || ''}</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Book Date</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{moment(DataObj.BookDt).format('DD-MM-YYYY')}</td>
            </tr>
            <tr style={{ backgroundColor: 'white' }}>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Mobile</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.MobileNo || ''}</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Email</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.Email || ''}</td>
            </tr>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>From Date</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{moment(DataObj.BookDtFrom).format('DD-MM-YYYY')}</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>To Date</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{moment(DataObj.BookUpToDt).format('DD-MM-YYYY')}</td>
            </tr>
            <tr style={{ backgroundColor: 'white' }}>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Duration</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.Duration || ''}</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Property Name</td>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.PropName || ''}</td>
            </tr>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Resident Name</td>
              <td colSpan="3" style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.ResidentName || ''}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Room Details */}
      <div style={{ marginBottom: '14px', position: 'relative' }}>
        <h3 className="sticky-section-header">Room Details</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ minWidth: '600px', width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
            <tbody>
              <tr style={{ backgroundColor: '#f9fafb' }}>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Wing</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.WingName || ''}</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Floor</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.FloorName || ''}</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Room Type</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.RoomTypeName || ''}</td>
              </tr>
              <tr style={{ backgroundColor: 'white' }}>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Bed No</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.RoombedName || DataObj.RoomNo || ''}</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Bed Type</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.RoomBedTypeName || DataObj.RoomTypeName ||  ''}</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Standard Rent</td>
                <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{DataObj.BedRent || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Plan Details */}
      <div style={{ marginBottom: '14px', overflowX: 'auto' }}>
        <h3 className="sticky-section-header">Plan Details</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ minWidth: '600px', width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
            <tbody>
              {[
                [['Plan', DataObj.PlanName || ''], ['Duration', DataObj.Duration || '']],
                [['Free Months', DataObj.FreeMonth || '0'], ['Min Adv Month', DataObj.LastAdjMonths || '0']],
                [['Increment %', DataObj.IncRentPerc || '0'], ['Deposit', DataObj.DepositeAmt || '']],
                [['Total Rent', DataObj.TotalRent || ''], ['Discount', DataObj.DiscAmt || '']],
                [['Net Amount', DataObj.NetAmt || ''], ['Monthly Amount', DataObj.MonthlyAmt || '']],
                [['Net Payable', DataObj.AdvcRcble || ''], ['', '']]
              ].map((row, idx) => (
                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#f9fafb' : 'white' }}>
                  <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[0][0]}</td>
                  <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{row[0][1]}</td>
                  <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[1][0]}</td>
                  <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{row[1][1]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Other Services */}
      <div style={{ marginBottom: '14px', overflowX: 'auto' }}>
        <h3 className='sticky-section-header'>Other Services</h3>
        <div style={{ overflow: 'auto' }}>
          <table style={{ minWidth: '600px', width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
            <tbody>
              {[
                [['Topup Amount', DataObj?.TopupAmt || ''], ['Transport Service', DataObj?.TAmount || '']],
                [['Mess Service', DataObj?.MessChrg || ''], ['Total Amount', DataObj?.TotNetAmt || '']]
              ].map((row, idx) => (
                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#f9fafb' : 'white' }}>
                  <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[0][0]}</td>
                  <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{row[0][1]}</td>
                  <td style={{ padding: '4px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[1][0]}</td>
                  <td style={{ padding: '4px', border: '1px solid #e5e7eb' }}>{row[1][1]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer */}
      <div style={{ marginTop: '16px', fontSize: '12px' }}>
        <p style={{ marginBottom: '2px' }}>Thank you for choosing Clanbridge Living Pvt Ltd</p>
        <p>For any queries, please contact: support@clanbridgeliving.in</p>
      </div>
    </div>
  );
};

export default BookingReportchekin;
